import * as React from "react";

import { useBrandingConfig } from "@needl-ai/common/branding";
import {
  SidebarHeader,
  useSidebar,
} from "@needl-ai/common/components/ui/sidebar";

import { ToggleSidebarButton } from "./ToggleSidebarButton";

type AppSidebarHeaderProps = {
  onLogoClick?: () => void;
};

export const AppSidebarHeader = ({ onLogoClick }: AppSidebarHeaderProps) => {
  const { state } = useSidebar();
  const collapsed = state === "collapsed";
  const branding = useBrandingConfig();

  const LogoComponent = collapsed
    ? branding.logo
    : branding.logoFull || branding.logo;
  const CollapsedLogo = branding.logo;
  const isImageLogo = typeof LogoComponent === "string";
  const isCollapsedImageLogo = typeof CollapsedLogo === "string";

  const renderLogo = (content: React.ReactNode, className: string) =>
    onLogoClick ? (
      <button
        type="button"
        onClick={onLogoClick}
        aria-label={`${branding.name} home`}
        className={`${className} cursor-pointer`}
      >
        {content}
      </button>
    ) : (
      <div className={className}>{content}</div>
    );

  return (
    <SidebarHeader className="p-4">
      <div className="flex items-center justify-between">
        {!collapsed &&
          renderLogo(
            <>
              {isImageLogo ? (
                <img
                  src={LogoComponent as string}
                  alt={`${branding.name} Logo`}
                  className="w-34 h-6 object-contain"
                />
              ) : (
                <div className={branding.logoFullClassName || "w-20 h-12"}>
                  <LogoComponent className="w-full h-full" />
                </div>
              )}
              {branding.showName && (
                <span className="font-semibold text-lg text-primary">
                  {branding.name}
                </span>
              )}
            </>,
            "flex items-center space-x-2"
          )}
        {collapsed &&
          renderLogo(
            isCollapsedImageLogo ? (
              <img
                src={branding.favicon || (CollapsedLogo as string)}
                alt={`${branding.name} Logo`}
                className="w-full h-full object-contain"
              />
            ) : (
              <CollapsedLogo className="w-full h-full" />
            ),
            "w-8 h-8"
          )}
        {!collapsed && <ToggleSidebarButton />}
      </div>
    </SidebarHeader>
  );
};
